import { Controller } from "@hotwired/stimulus"

// All You destinations share a sidebar and its compact mobile picker.
export default class extends Controller {
  static targets = ["select"]

  navigate(event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    event.preventDefault()
    this.go(event.currentTarget.href)
  }

  select(event) { this.go(event.target.value) }

  async go(path) {
    const url = new URL(path, window.location.href)
    const page = this.application.getControllerForElementAndIdentifier(this.element, "profile-settings")
    if (page && url.pathname === window.location.pathname) {
      await page.go(url.searchParams.get("panel") || "overview")
      return
    }
    for (const form of document.querySelectorAll('[data-controller~="profile-autosave"]')) {
      const controller = this.application.getControllerForElementAndIdentifier(form, "profile-autosave")
      if (controller && !(await controller.flush())) {
        this.restoreSelection()
        return
      }
    }
    window.location.assign(url.href)
  }

  restoreSelection() {
    const current = this.element.querySelector('nav a[aria-current="page"]')
    if (current) this.selectTarget.value = current.getAttribute("href")
  }
}
